// extracted by mini-css-extract-plugin
export default {"coursesNav":"Home_coursesNav__NAdzW","itemCourses":"Home_itemCourses__ICXBG","listCourses":"Home_listCourses__fFCe5","searchChip":"Home_searchChip__l0HEM"};